export default __webpack_public_path__ + "static/media/carlLoryDownload.16b2b9fb.png";